export const navigationCodes = {
	securityStatement: 293,
	privacyStatement: 294,
	termsOfUse: 295,
	aboutUs: 296,
	contactUs: 291,
	admin: 313,
	cvdPolicy: 11351,
	help: 14939,
	learnings: 14940,
	general: 16551,
	dashboard: 16552,
	managementInformation: 16553,
	agency: 16554,
	agencyList: 16555,
	agencyStructure: 16556,
	employer: 16557,
	employerList: 16558,
	employerContactPersonsList: 16559,
	dealList: 16560,
	supplierOrganizationList: 16561,
	candidate: 16562,
	candidateList: 16563,
	candidateChangeList: 16564,
	candidatePeriodicComponentsList: 16565,
	candidateCandidateStatusMapping: 16566,
	proformaList: 16567,
	contract: 16568,
	contractList: 16569,
	contractBulkUpdateRequestList: 16570,
	document: 16571,
	documentList: 16572,
	documentSettingsList: 16573,
	timecard: 16574,
	timecardList: 16575,
	invoice: 16576,
	invoiceList: 16577,
	invoicePurchaseInvoice: 16578,
	backoffice: 16579,
	backofficeIndex: 16580,
	backofficeProcessinglist: 16581,
	backofficeTransferfiles: 16582,
	backofficeJournalTransferFilesList: 16583,
	backofficePaymentTransferFilesList: 16584,
	payslip: 16585,
	payslipList: 16586,
	candidatePhase: 16587,
	candidatePhaseList: 16588,
	pension: 16589,
	pensionList: 16590,
	illness: 16591,
	illnessList: 16592,
	candidateReservation: 16593,
	candidateReservationList: 16594,
	payment: 16595,
	paymentList: 16596,
	newsroom: 16597,
	newsList: 16598,
	commentList: 16599,
	communitiesList: 16600,
	home: 16601,
	publicEmployerEmployerList: 16602,
	publicJobJobList: 16603,
	publicJobAlljobs: 16604,
	job: 16605,
	jobJobList: 16606,
	workflow: 16607,
	taskList: 16608,
	activityList: 16609,
	user: 16610,
	userList: 16611,
	subscriberSubscriberList: 16612,
	role: 16613,
	roleList: 16614,
	connect: 16615,
	connectIncomingList: 16616,
	connectIncomingLogList: 16617,
	connectOutgoingList: 16618,
	connectOutgoingLogList: 16619,
	connectSettings: 16620,
	connectEmailSenderauthList: 16621,
	connectApiUserList: 16622,
	connectorList: 16623,
	connectCustomerAccessRequestList: 16624,
	connectFsApiLogList: 16625,
	connectDashboard: 16626,
	caowijzerCustomCao: 16683,
	caowijzer: 16627,
	caowijzerCaoNewsList: 16628,
	caowijzerCaoList: 16629,
	caowijzerCaoInstanceList: 16630,
	caowijzerCaoWagesList: 16631,
	caowijzerCaoWagesRequestsList: 16632,
	caowijzerWmlList: 16633,
	application: 16634,
	applicationList: 16635,
	applicationForm: 16636,
	customer: 16637,
	customerCustomerList: 16638,
	invoiceComponentsList: 16639,
	customerInvoiceList: 16640,
	customerSubscriptionList: 16641,
	customerSubscriptionSettingList: 16642,
	label: 16643,
	labelLabelList: 16644,
	labelTranslations: 16645,
	labelTemplates: 16646,
	labelPagesList: 16647,
	tag: 16648,
	tagList: 16649,
	share: 16650,
	shareJobboardInstanceList: 16651,
	shareJobboardList: 16652,
	shareJobpostList: 16653,
	shareSharelogList: 16654,
	survey: 16691,
	surveyList: 16656,
	newsAdmin: 16657,
	newsAdminList: 16658,
	form: 16659,
	formUserList: 16660,
	safety: 16661,
	safetyList: 16661,
	savedFilter: 16663,
	savedFilterMyFiltersList: 16664,
	savedFilterSystemFiltersList: 16665,
	savedFilterOtherUsersFiltersList: 16666,
	savedFilterAlertLogsList: 16667,
	rateClasses: 16668,
	rateClassesList: 16669,
	calculationScheme: 16670,
	calculationSchemeList: 16671,
	domainValues: 16672,
	domainValuesList: 16673,
	domainValuesMapping: 16674,
	domainValuesCaoMapping: 16675,
	modelMatrix: 16676,
	modelMatrixList: 16677,
	modelMatrixInstanceList: 16678,
	componentModel: 16679,
	componentModelList: 16680,
	documentTemplate: 16681,
	documentTemplateList: 16682,
	caowijzerCustomCaoList: 16684,
	caowijzerCustomCaoInstanceList: 16685,
	textModel: 16686,
	textModelList: 16687,
	auditTrail: 16688,
	auditTrailList: 16689,
	settingList: 16690,
	surveySurveyAdminList: 16692,
	surveyListOptOutList: 16693,
	flexNetBundle: 16694,
	flexNetBundleList: 16695,
	flexNetHostList: 16696,
	flexNetCustomerList: 16697,
	flexNetHostSettings: 16698,
	formDesigner: 16699,
	formDesignerList: 16700,
	automation: 16701,
	automationList: 16702,
	automationLogList: 16703,
	candidateMyProfile: 16721,
	employerMyOrganization: 16722,
	crm: 16737,
	hrm: 16738,
	salaryInformation: 16739,
	recruitment: 16740,
	communication: 16741,
	tasksAndActivities: 16742,
	access: 16743,
	contractConditions: 16744,
	contractConditionsList: 16745,
	contractConditionsByBureauList: 16746,
	models: 16747,
	mapping: 16748,
	filtersAndAlerts: 16749,
	savedFilterPersonalList: 16750,
	savedFilterOrganisationList: 16751,
	subscriptionConfigurationList: 16752,
	labelConfigurationList: 16753,
	labelHomePage: 16754,
	smartTasksList: 16755,
	supportAndLearning: 16756,
	menu: 16757,
	configuration: 16758,
	smartTasks: 16760,
	subscribersJobAlertList: 16761,
	caoAndCustomAgreementsMappingList: 16762,
	jobboardDomainsMappingList: 16763,
	auditTrailSettingsLogList: 16764,
} as const;
